import React from 'react';
import { 
  // Base
  User, Flag, Map, Box, ShoppingBag, Star, Zap, Wrench, 
  // Educación
  Book, BookOpen, Calendar, GraduationCap, Trophy, 
  // Creatividad y Mente
  Lightbulb, Music, Video, Brain, Pencil, 
  // Ropa y Accesorios
  Shirt, Crown, Watch, Footprints,
  // Trabajo y Negocios
  Briefcase, Laptop, Presentation, HardHat, Coffee,
  // Verbos y Acciones
  Play, Smile, Utensils, Mic, Waves, Bike,
  // Lugares y Naturaleza
  Home, Store, Trees, Plane, Car, Dog,
} from 'lucide-react';

export const getIcon = (type) => {
  const iconKey = type?.toLowerCase();

  switch(iconKey) {
    // --- BÁSICOS ---
    case 'user': case 'profile': return <User size={20}/>;
    case 'flag': case 'country': return <Flag size={20}/>;
    case 'map': case 'place': return <Map size={20}/>;
    case 'box': case 'object': return <Box size={20}/>;
    case 'star': return <Star size={20} className="text-amber-500"/>;

    // --- ROPA (Clothes) ---
    case 'clothes': case 'shirt': case 'ropa': return <Shirt size={20} className="text-blue-400"/>;
    case 'shoes': case 'footprints': case 'zapatos': return <Footprints size={20} className="text-orange-700"/>;
    case 'crown': case 'jewelry': case 'joyas': return <Crown size={20} className="text-yellow-500"/>;
    case 'watch': case 'reloj': return <Watch size={20} className="text-slate-400"/>;

    // --- TRABAJO (Work/Business) ---
    case 'work': case 'job': case 'briefcase': case 'trabajo': return <Briefcase size={20} className="text-amber-800"/>;
    case 'laptop': case 'tech': case 'tecnologia': return <Laptop size={20} className="text-slate-600"/>;
    case 'presentation': case 'class': case 'aula': return <Presentation size={20} className="text-indigo-500"/>;
    case 'construction': case 'hardhat': return <HardHat size={20} className="text-orange-500"/>;

    // --- VERBOS Y ACCIONES ---
    case 'eat': case 'food': case 'utensils': case 'comer': return <Utensils size={20} className="text-rose-500"/>;
    case 'drink': case 'coffee': case 'beber': return <Coffee size={20} className="text-amber-600"/>;
    case 'speak': case 'talk': case 'mic': case 'hablar': return <Mic size={20} className="text-sky-500"/>;
    case 'swim': case 'waves': case 'nadar': return <Waves size={20} className="text-blue-400"/>;
    case 'run': case 'sport': case 'exercise': return <Bike size={20} className="text-green-500"/>;
    case 'feel': case 'emotions': case 'smile': return <Smile size={20} className="text-yellow-400"/>;

    // --- VIAJES Y LUGARES ---
    case 'travel': case 'plane': case 'avion': return <Plane size={20} className="text-sky-400"/>;
    case 'car': case 'drive': case 'conducir': return <Car size={20} className="text-slate-500"/>;
    case 'home': case 'house': case 'casa': return <Home size={20} className="text-rose-400"/>;
    case 'store': case 'shop': case 'tienda': return <Store size={20} className="text-emerald-500"/>;
    case 'nature': case 'trees': case 'naturaleza': return <Trees size={20} className="text-green-600"/>;

    // --- EDUCACIÓN Y REPASO ---
    case 'book': case 'libro': return <Book size={20} className="text-emerald-500"/>;
    case 'reading': case 'book-open': return <BookOpen size={20} className="text-blue-500"/>;
    case 'review': case 'graduation': case 'examen': return <GraduationCap size={20} className="text-purple-500"/>;
    case 'trophy': case 'win': case 'final': return <Trophy size={20} className="text-amber-500"/>;

    // --- OTROS ---
    case 'wrench': case 'settings': return <Wrench size={20} className="text-slate-500"/>;
    case 'music': return <Music size={20} className="text-pink-500"/>;
    case 'idea': return <Lightbulb size={20} className="text-yellow-500"/>;
    case 'brain': return <Brain size={20} className="text-cyan-500"/>;
// --- MASCOTAS / HUELLAS ---
   case 'paw': 
   case 'mascota': 
   case 'huella': 
   case 'animal': return <Dog size={20} className="text-amber-600"/>;
    // --- DEFECTO ---
    default: return <Zap size={20} className="text-amber-400"/>;
  }
};